<template>
  <v-toolbar app>
    <v-layout align-center>
      <!-- logo -->
      <a href="https://kontinentalist.com/">
        <img
          src="@/assets/img/logo.svg"
          alt="kontinentalist-logo"
          width="40px">
      </a>

      <!-- post title -->
      <v-toolbar-title>
        <div>
          <span class="body-1 font-weight-bold primary--text font-secondary">You are reading: </span>
          <h2 class="body-2 font-secondary font-weight-bold d-inline ml-1">Understanding the Belt & Road</h2>
        </div>
      </v-toolbar-title>

      <v-spacer/>

      <!-- social sharing -->
      <v-toolbar-items>
        <AppButtonSocialFacebook />

        <AppButtonSocialTwitter />

        <AppButtonSocialCopy />

      </v-toolbar-items>
    </v-layout>
  </v-toolbar>
</template>

<script>
import AppButtonSocialFacebook from '@/components/ui/AppButtonSocialFacebook.vue';
import AppButtonSocialTwitter from '@/components/ui/AppButtonSocialTwitter.vue';
import AppButtonSocialCopy from '@/components/ui/AppButtonSocialCopy.vue';

export default {
  name: 'TheNavbarBeta',
  components: {
    AppButtonSocialFacebook,
    AppButtonSocialTwitter,
    AppButtonSocialCopy,
  },
};
</script>
